import Lottie from 'lottie-react'
import Loading from '@/assets/lottie/Insider-loading.json'

const LoadingScreen = () => {
    return (
        <div className="flex items-center justify-center w-screen h-screen">
            <Lottie animationData={Loading} className="md:w-1/4 " />
        </div>
    )
}

export default LoadingScreen
